/* =====================================================
   DIVINO ENCANTO — THEME.JS
   Desenvolvido por nobreack.com
   Handles: mobile menu, cart drawer, scroll animations,
            tabs, header scroll, quantity inputs, mobile accordions,
            AJAX cart form submissions
   ===================================================== */
(function () {
  'use strict';

  /* ── Helpers ── */
  const qs  = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on  = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  /* ── DOM Ready ── */
  document.addEventListener('DOMContentLoaded', () => {
    initDrawersAndMenu();
    initMobileAccordions();
    initCartFormAjax();
    initCartDrawerActions();
    initScrollAnimations();
    initStickyHeader();
    initTabs();
    initQuantityInputs();
    initProductImageSwitch();
    initAnnouncementBar();
  });

  /* ─────────────────────────────────────────────────
     DRAWERS & MOBILE MENU (Event Delegation)
     ───────────────────────────────────────────────── */
  function initDrawersAndMenu() {
    const overlay = qs('#overlay');
    
    // Toggle mobile menu
    const toggleMenu = (open) => {
      const menu = qs('#mobile-menu');
      if (!menu) return;
      menu.classList.toggle('active', open);
      overlay?.classList.toggle('active', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };

    // Toggle cart drawer
    const toggleCart = (open) => {
      const drawer = qs('#cart-drawer');
      if (!drawer) return;
      drawer.classList.toggle('active', open);
      overlay?.classList.toggle('active', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };

    // Toggle search drawer
    const toggleSearch = (open) => {
      const drawer = qs('#search-drawer');
      if (!drawer) return;
      drawer.classList.toggle('active', open);
      overlay?.classList.toggle('active', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        setTimeout(() => drawer.querySelector('input[type="text"]')?.focus(), 250);
      }
    };

    const closeAll = () => {
      qs('#mobile-menu')?.classList.remove('active');
      qs('#cart-drawer')?.classList.remove('active');
      qs('#search-drawer')?.classList.remove('active');
      overlay?.classList.remove('active');
      document.body.style.overflow = '';
    };

    // Delegate click events on document
    document.addEventListener('click', (e) => {
      const menuOpenBtn  = e.target.closest('[data-menu-open]');
      const menuCloseBtn = e.target.closest('[data-menu-close]');
      const cartOpenBtn  = e.target.closest('[data-cart-open]');
      const cartCloseBtn = e.target.closest('[data-cart-close]');
      const searchOpenBtn = e.target.closest('[data-search-open]');
      const searchCloseBtn = e.target.closest('[data-search-close]');
      const isOverlay    = e.target === overlay;

      if (menuOpenBtn) {
        e.preventDefault();
        toggleMenu(true);
      } else if (menuCloseBtn) {
        e.preventDefault();
        toggleMenu(false);
      } else if (cartOpenBtn) {
        e.preventDefault();
        toggleCart(true);
      } else if (cartCloseBtn) {
        e.preventDefault();
        toggleCart(false);
      } else if (searchOpenBtn) {
        e.preventDefault();
        toggleSearch(true);
      } else if (searchCloseBtn) {
        e.preventDefault();
        toggleSearch(false);
      } else if (isOverlay) {
        closeAll();
      }
    });
  }

/* ─────────────────────────────────────────────────
     MOBILE ACCORDIONS (Suporte Completo a Submenus Aninhados)
     ───────────────────────────────────────────────── */
  function initMobileAccordions() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-submenu-toggle]');
      if (!trigger) return;
      e.preventDefault();
      
      const item = trigger.closest('.mobile-menu__item');
      if (!item) return;
      
      const submenu = item.querySelector(':scope > .mobile-menu__submenu');
      if (!submenu) return;
      
      const isOpen = item.classList.contains('is-open');

      // Fecha irmãos no mesmo nível
      const parentContainer = item.parentElement;
      const siblings = parentContainer.querySelectorAll(':scope > .mobile-menu__item.is-open');
      siblings.forEach(openItem => {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          const sub = openItem.querySelector(':scope > .mobile-menu__submenu');
          if (sub) sub.style.maxHeight = null;
          const trig = openItem.querySelector(':scope > [data-submenu-toggle]');
          if (trig) trig.setAttribute('aria-expanded', 'false');
        }
      });

      // Atualiza a altura de todos os menus pais na hierarquia
      const updateParentHeights = () => {
        let parentSub = item.parentElement.closest('.mobile-menu__submenu');
        while (parentSub) {
          let totalHeight = 0;
          [...parentSub.children].forEach(child => {
            totalHeight += child.offsetHeight || child.scrollHeight;
          });
          parentSub.style.maxHeight = (parentSub.scrollHeight + totalHeight) + 'px';
          parentSub = parentSub.parentElement.closest('.mobile-menu__submenu');
        }
      };

      if (isOpen) {
        item.classList.remove('is-open');
        submenu.style.maxHeight = null;
        trigger.setAttribute('aria-expanded', 'false');
        updateParentHeights();
      } else {
        item.classList.add('is-open');
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        trigger.setAttribute('aria-expanded', 'true');
        
        requestAnimationFrame(() => {
          updateParentHeights();
        });
      }
    });
  }

  /* ─────────────────────────────────────────────────
     AJAX CART FORM SUBMIT
     ───────────────────────────────────────────────── */
  function initCartFormAjax() {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('#product-form, form[action="/cart/add"]');
      if (!form) return;

      const submitBtn = e.submitter || form.querySelector('[type="submit"]');
      const isBuyNow  = submitBtn && submitBtn.hasAttribute('data-buy-now');

      if (isBuyNow) {
        let returnInput = form.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          form.appendChild(returnInput);
        }
        returnInput.value = '/checkout';
        return; // Allow native form submission to redirect to checkout
      }

      // Normal Add to Cart (AJAX)
      e.preventDefault();

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('data-original-text', submitBtn.innerText);
        submitBtn.innerText = 'Adicionando...';
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(item => {
        // Re-fetch current page dynamic HTML to update cart drawer contents
        return fetch(window.location.pathname);
      })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Update drawer content (body + footer)
        const newDrawerContent = doc.querySelector('#cart-drawer-content');
        const currentDrawerContent = qs('#cart-drawer-content');
        if (newDrawerContent && currentDrawerContent) {
          currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
        }
        
        // Update cart count badge
        const newCartCount = doc.querySelector('.header__cart-count');
        const currentCartBtn = qs('.header__cart-btn');
        if (currentCartBtn) {
          let countBadge = qs('.header__cart-count', currentCartBtn);
          if (newCartCount) {
            if (!countBadge) {
              countBadge = document.createElement('span');
              countBadge.className = 'header__cart-count';
              currentCartBtn.appendChild(countBadge);
            }
            countBadge.innerText = newCartCount.innerText;
          } else if (countBadge) {
            countBadge.remove();
          }
        }

        // Re-enable submit button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerText = 'Adicionado!';
          setTimeout(() => {
            submitBtn.innerText = submitBtn.getAttribute('data-original-text') || 'Adicionar ao Carrinho';
          }, 2000);
        }

        // Slide open the cart drawer!
        const drawer = qs('#cart-drawer');
        const overlay = qs('#overlay');
        if (drawer && overlay) {
          drawer.classList.add('active');
          overlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerText = submitBtn.getAttribute('data-original-text') || 'Adicionar ao Carrinho';
        }
        // Fallback: submit form traditionally if AJAX fails
        form.submit();
      });
    });
  }

  /* ─────────────────────────────────────────────────
     SCROLL ANIMATIONS (Intersection Observer)
     ───────────────────────────────────────────────── */
  function initScrollAnimations() {
    const els = qsa('[data-animate]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('in-view'));
      return;
    }
    const io = new IntersectionObserver(
      entries => entries.forEach(e => e.isIntersecting && e.target.classList.add('in-view')),
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(el => io.observe(el));
  }

  /* ─────────────────────────────────────────────────
     STICKY HEADER — shrink on scroll
     ───────────────────────────────────────────────── */
  function initStickyHeader() {
    const header = qs('.header');
    if (!header) return;
    let last = 0;
    const handle = () => {
      const y = window.scrollY;
      header.classList.toggle('header--scrolled', y > 60);
      header.classList.toggle('header--hidden', y > last + 5 && y > 200);
      last = y;
    };
    on(window, 'scroll', handle, { passive: true });
  }

  /* ─────────────────────────────────────────────────
     TABS
     ───────────────────────────────────────────────── */
  function initTabs() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.tab-btn');
      if (!btn) return;
      const wrapper = btn.closest('[data-tabs]');
      if (!wrapper) return;
      const target = btn.dataset.tab;
      const btns = qsa('.tab-btn', wrapper);
      const panels = qsa('.tab-panel', wrapper);
      btns.forEach(b => b.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      qs(`[data-tab-panel="${target}"]`, wrapper)?.classList.add('active');
    });
  }

  /* ─────────────────────────────────────────────────
     QUANTITY INPUTS
     ───────────────────────────────────────────────── */
  function initQuantityInputs() {
    document.addEventListener('click', (e) => {
      const dec = e.target.closest('[data-qty-dec]');
      const inc = e.target.closest('[data-qty-inc]');
      if (dec || inc) {
        const wrapper = e.target.closest('.qty-wrapper');
        const input = qs('input[type="number"]', wrapper);
        if (!input) return;
        if (dec) {
          if (input.value > 1) input.value = +input.value - 1;
        } else if (inc) {
          input.value = +input.value + 1;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ─────────────────────────────────────────────────
     PRODUCT IMAGE SWITCH (hover alt image)
     ───────────────────────────────────────────────── */
  function initProductImageSwitch() {
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('.product-card');
      if (!card) return;
      const main = qs('.product-card__media img', card);
      const alt  = qs('.product-card__media-alt img', card);
      if (main && alt) {
        main.style.opacity = '0';
        alt.style.opacity = '1';
      }
    });
    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('.product-card');
      if (!card) return;
      const main = qs('.product-card__media img', card);
      const alt  = qs('.product-card__media-alt img', card);
      if (main && alt) {
        main.style.opacity = '1';
        alt.style.opacity = '0';
      }
    });
  }

  /* ─────────────────────────────────────────────────
     ANNOUNCEMENT BAR — auto-rotate messages
     ───────────────────────────────────────────────── */
  function initAnnouncementBar() {
    const msgs = qsa('.announcement-bar__message');
    if (msgs.length <= 1) return;
    let i = 0;
    msgs.forEach((m, idx) => { m.style.display = idx === 0 ? 'flex' : 'none'; });
    setInterval(() => {
      if (msgs[i]) msgs[i].style.display = 'none';
      i = (i + 1) % msgs.length;
      if (msgs[i]) msgs[i].style.display = 'flex';
    }, 4000);
  }

  /* ─────────────────────────────────────────────────
     CART DRAWER AJAX ACTIONS (Quantity/Remove)
     ───────────────────────────────────────────────── */
  function initCartDrawerActions() {
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-cart-remove]');
      const qtyBtn = e.target.closest('[data-qty-change]');
      
      if (!removeBtn && !qtyBtn) return;
      
      e.preventDefault();
      
      let key = '';
      let newQty = 0;
      
      if (removeBtn) {
        key = removeBtn.getAttribute('data-cart-remove');
        newQty = 0;
      } else if (qtyBtn) {
        key = qtyBtn.getAttribute('data-key');
        const change = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
        const qtyContainer = qtyBtn.closest('div');
        const qtySpan = qtyContainer ? qtyContainer.querySelector('span') : null;
        if (!qtySpan) return;
        const currentQty = parseInt(qtySpan.innerText, 10);
        newQty = currentQty + change;
        if (newQty < 1) newQty = 0; // Se menor que 1, remove o item
      }
      
      updateCartItemQuantity(key, newQty);
    });
  }

  function updateCartItemQuantity(key, quantity) {
    const drawerBody = qs('#cart-drawer-body');
    if (drawerBody) {
      drawerBody.style.opacity = '0.5';
      drawerBody.style.pointerEvents = 'none';
    }
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to update cart');
      return response.json();
    })
    .then(cartJson => {
      // Re-fetch current page dynamic HTML to update cart drawer contents
      return fetch(window.location.pathname);
    })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update drawer content (body + footer)
      const newDrawerContent = doc.querySelector('#cart-drawer-content');
      const currentDrawerContent = qs('#cart-drawer-content');
      if (newDrawerContent && currentDrawerContent) {
        currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
        const newBody = qs('#cart-drawer-body', currentDrawerContent);
        if (newBody) {
          newBody.style.opacity = '1';
          newBody.style.pointerEvents = 'all';
        }
      }
      
      // Update cart count badge
      const newCartCount = doc.querySelector('.header__cart-count');
      const currentCartBtn = qs('.header__cart-btn');
      if (currentCartBtn) {
        let countBadge = qs('.header__cart-count', currentCartBtn);
        if (newCartCount) {
          if (!countBadge) {
            countBadge = document.createElement('span');
            countBadge.className = 'header__cart-count';
            currentCartBtn.appendChild(countBadge);
          }
          countBadge.innerText = newCartCount.innerText;
        } else if (countBadge) {
          countBadge.remove();
        }
      }
      
      // Se estiver na página do carrinho principal, recarrega para manter sincronizado
      if (window.location.pathname === '/cart') {
        window.location.reload();
      }
    })
    .catch(error => {
      console.error('Error updating cart drawer:', error);
      if (drawerBody) {
        drawerBody.style.opacity = '1';
        drawerBody.style.pointerEvents = 'all';
      }
    });
  }

})();
